import styled from 'styled-components';
import { variant } from 'styled-system';

import { ThemeUtilities } from '../../../theme';
import { Size, Mode } from './types';

export const Container = styled.div<{ size: Size; mode: Mode }>`
  box-sizing: border-box;
  display: inline-block;

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Tooltip', 'size'))};

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Tooltip', 'mode'))};
`;
